import React, { useState } from 'react';
import './FAQ.css';
import Footer from './Footer';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="body">
      <div className="section is--hero">
        <div className="container-2">
          <h1 className="h1" style={{marginBottom:"0px"}}>FAQ</h1>
        </div>
      </div>
      <div className="section is--pricing" style={{padding:"10px 0px"}}>
        <div className="container-2">
          <div className="section-header is--pricing">
            <div className="mb-5 mb-0">
              <div className="card border-0 clearfix">
                <div className="card-header"></div>
                <div className="card-body">
                  <div className="about-author">
                    <div className="faq-category">
                      <h3 className="faq-category-title">Frequently Asked Questions (Website)</h3>
                      <div className={`faq-item ${activeIndex === 0 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(0)}>
                          <h3>What plan works for me?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>If your business requires general support, then choose the Team Premium plan.<br /> If your business requires a dedicated support team, then choose the Team Ace plan.</p>
                        </div>
                      </div>
                      <div className={`faq-item ${activeIndex === 1 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(1)}>
                          <h3>How are payments processed for the plan?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>Choose your plan and make payment. Once you purchase a plan, our payment gateway will automatically process your payment based on your billing cycle.</p>
                        </div>
                      </div>
                      <div className={`faq-item ${activeIndex === 2 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(2)}>
                          <h3>Is my payment secure?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>Yes, our payment gateway has been audited by a PCI-certified auditor and is certified to PCI Service Provider Level 1. This is the most stringent level of certification available in the payments industry. Our payment gateway uses the best-in-class security tools and practices to maintain a high level of security.</p>
                        </div>
                      </div>
                      <div className={`faq-item ${activeIndex === 3 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(3)}>
                          <h3>Can we cancel the plan?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>Yes, you can login to your admin panel and cancel your subscription at any time.</p>
                          <div className="note-box">
                            <span className="note-icon">👁️</span>
                            <strong>Note:</strong> All payments are non-refundable.
                          </div>
                        </div>
                      </div>
                      <div className={`faq-item ${activeIndex === 4 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(4)}>
                          <h3>Have additional questions?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>Contact support@eworxs.app</p>
                        </div>
                      </div>
                    </div>

                    <div className="faq-category">
                      <h3 className="faq-category-title">Frequently Asked Questions (Admin)</h3>
                      <div className={`faq-item ${activeIndex === 5 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(5)}>
                          <h3>What are the functionalities of the Admin panel in the Team Plan?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>In the Admin panel you can add your clients, add your worker, check your workers' visit, run reports, export data to an accounting software such as QuickBooks</p>
                        </div>
                      </div>
                      <div className={`faq-item ${activeIndex === 6 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(6)}>
                          <h3>Can I extract data to pay my workers?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>Yes, you just need to run a report that shows the amount due to that worker</p>
                        </div>
                      </div>
                      <div className={`faq-item ${activeIndex === 7 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(7)}>
                          <h3>Can we Upgrade the plan later?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>Yes, for sure.</p>
                        </div>
                      </div>
                      <div className={`faq-item ${activeIndex === 8 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(8)}>
                          <h3>Can a worker change his/her password?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>No. The Master Administrator is the only person authorized to change the worker's password.</p>
                        </div>
                      </div>
                      <div className={`faq-item ${activeIndex === 9 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(9)}>
                          <h3>How do I login to the Admin portal?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>Only the Master Administrator/the business owner can login after signing up on the website, go to signin and login to the Admin portal.</p>
                        </div>
                      </div>
                      <div className={`faq-item ${activeIndex === 10 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(10)}>
                          <h3>Can we add workers ourselves?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>Yes, for sure! You must have a Team Plan to add workers. Only the Master Administrator/the business owner can add workers.</p>
                        </div>
                      </div>
                      <div className={`faq-item ${activeIndex === 11 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(11)}>
                          <h3>How do I add workers?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>You just need to log in and add the workers on your company's dashboard. After logging in, locate the Worker List tab and add your workers' information</p>
                        </div>
                      </div>
                      <div className={`faq-item ${activeIndex === 12 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(12)}>
                          <h3>How do I add clients?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>You just need to log in and add the client on your company's dashboard. After login in, locate the Client Companies tab and add your clients' information</p>
                        </div>
                      </div>
                      <div className={`faq-item ${activeIndex === 13 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(13)}>
                          <h3>Can I choose to send the invoices manually?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>Yes, you can. You must complete the profile page and not select "send invoice to client." The invoices will remain in your Admin portal for download. Note this will apply to all invoices sent by your company.</p>
                        </div>
                      </div>
                      <div className={`faq-item ${activeIndex === 14 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(14)}>
                          <h3>Can I change from manual to automatic and vice versa in sending my invoices?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>Yes, update your preferences under your profile page.</p>
                        </div>
                      </div>
                      <div className={`faq-item ${activeIndex === 15 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(15)}>
                          <h3>Have additional questions?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>Contact support@eworxs.app</p>
                        </div>
                      </div>
                      <div className={`faq-item ${activeIndex === 16 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(16)}>
                          <h3>How do I export my Invoices into Quickbooks Online?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>Super easy: Click <a href="QBO_online_export_instructions.pdf">here</a> for the instructions.</p>
                        </div>
                      </div>
                    </div>

                    <div className="faq-category">
                      <h3 className="faq-category-title">Frequently Asked Questions (Mobile APP)</h3>
                      <div className={`faq-item ${activeIndex === 17 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(17)}>
                          <h3>How does the Eworxs mobile app work?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>Super easy, Master Administrator/the business owner logs into the admin portal and creates the worker's login ID and password. The Master Administrator provides this login information to the worker. The worker downloads the Eworxs app from Play store or App Store for Android and IPhone phones respectively. The worker then logs in with the login information.</p>
                        </div>
                      </div>
                      <div className={`faq-item ${activeIndex === 18 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(18)}>
                          <h3>Does the Eworxs app track mileage?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>Yes, it tracks the mileage from your worker's residence (included in Eworxs app, when the worker is set up) to the client's/customer's location.</p>
                        </div>
                      </div>
                      <div className={`faq-item ${activeIndex === 19 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(19)}>
                          <h3>Does the Eworxs app send invoices?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>Yes, the Eworxs app makes invoice sending very easy; when the worker completes their visit, the Eworxs app automatically generates and sends the invoice.</p>
                        </div>
                      </div>
                      <div className={`faq-item ${activeIndex === 20 ? 'active' : ''}`}>
                        <div className="faq-question" onClick={() => toggleFAQ(20)}>
                          <h3>Can I include an attachment with the invoices?</h3>
                        </div>
                        <div className="faq-answer">
                          <p>Yes, you can photograph a document with you camera, then select add from gallery to attach it to the invoice.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default FAQ; 
